<script>
import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  props: {
    chartdata: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      defaultOptions: {
        legend: { position: "bottom", labels: { usePointStyle: true } },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                callback: function (value) {
                  return (
                    "$" + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  );
                },
              },
              scaleLabel: { display: true, labelString: "Ventas" },
            },
          ],
          xAxes: [
            {
              ticks: { autoSkip: false, maxRotation: 0, minRotation: 0 },
              // barThickness: 20,
              categoryPercentage: 0.7,
              barPercentage: 0.8,
              offset: true,
              scaleLabel: { display: true, labelString: "Meses" },
            },
          ],
        },

        tooltips: {
          enabled: true,
          mode: "index",
          intersect: false,
          bodyFontSize: 16, // tamaño del texto del body
          titleFontSize: 18, // tamaño del título (mes)
          bodyFontStyle: "bold", // texto en negrita
          titleFontStyle: "bold",
          callbacks: {
            label: function (tooltipItem) {
              return (
                "$" +
                Number(tooltipItem.yLabel).toLocaleString("es-AR", {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                })
              );
            },
          },
          backgroundColor: "rgba(0,0,0,0.8)", // fondo del tooltip
          titleFontColor: "#ffffff",
          bodyFontColor: "#ffffff",
          xPadding: 10,
          yPadding: 10,
          caretSize: 6,
        },
        animation: { duration: 500 },
        responsiveAnimationDuration: 2,
        maintainAspectRatio: false,
      },
    };
  },
  mounted() {
    const finalOptions = this.options || this.defaultOptions;
    this.renderChart(this.chartdata, finalOptions);
  },
};
</script>
